import React from 'react'
import PropTypes from 'prop-types'
import ActionsModal from 'components/ActionsModal'

export default function DeleteOrganizationModal({ organization, onSubmit, onClose }) {
  return (
    <ActionsModal
      type='organization'
      mode='delete'
      item={organization}
      primaryKey='name'
      fields={{}}
      onFieldChange={() => {}}
      onClose={onClose}
      onSubmit={() => onSubmit(organization)}
      confirmMessage={`Are you sure you want to delete "${organization?.name}"?`}
      confirmLabel='Delete'
      confirmColor='danger'
      cancelLabel='Cancel'
    />
  )
}

DeleteOrganizationModal.propTypes = {
  organization: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
} 